/* eslint-disable @typescript-eslint/naming-convention */

export enum ChangeLogAction {
    Insert = 'Insert',
    Update = 'Update',
    Delete = 'Delete'
}

export interface ChangeLogItem {
    Id: number;
    EntityType: string;
    EntityId: string;
    EntityDisplayName: string;
    EntityDisplayValue: string;
    ParentEntityName: string;
    ParentEntityId: string;
    LogAction: ChangeLogAction;
    JsonLog: string;
    CreatedDate: Date;
    CreatedBy: number;
}

export interface ChangeLogItemDisplay extends ChangeLogItem {
    columns: any[];
    rows: any[];
}
